import { getHostURL } from '../utils/GeneralUtil';
export var shared = {
    title: "National Account Incentives",
    cancel: "Cancel",
    continue: "Continue",
    enroll: "Enroll",
    type: "NAI",
};
export var nationalAccountRegex = {
    inputRegex: /^$|^[0-9A-Za-z-_\s]{1,12}$/,
    einRegex: /(\d{2})[-]?(\d{7})/,
};
export var mainPageBlurb = 'Members of Pro Xtra and participating National Accounts and Affiliations may qualify for additional benefits.';
export var modalBlurbs = {
    enroll: {
        content: {
            line1: 'As a member of Pro Xtra and a participating National Association or Affiliation, you are eligible for exclusive benefits at The Home Depot.',
            line2: 'If your organization has provided you with a National Agreement Code, you can enroll now.',
        },
        buttons: {
            continue: 'Validate Code',
            cancel: 'Cancel',
        },
        tooltip: 'Note: this is not a promo code.',
        agreementCode: 'Agreement Code',
    },
    confirm: {
        content: {
            line1: 'Click Enroll below to complete enrollment in this program.',
        },
        buttons: {
            continue: 'Enroll',
            cancel: 'Cancel',
        },
        name: 'Name:',
        code: 'Code:',
        validAgreementCode: 'Valid Agreement Code',
    },
    unenroll: {
        buttons: {
            continue: 'Enroll',
            cancel: 'Cancel',
            unenroll: 'Unenroll',
            unEnrollCancel: 'Wait! Keep it',
            unEnrollConfirm: 'Yes, Unenroll',
        },
        title: {
            unenrollIncentives: 'Unenroll from Incentives',
            unenrollConfirmation: 'Unenrollment Confirmation',
        },
        unenrollDoubleCheck: 'Are you sure you want to unenroll from the National Account Incentives Program below?',
        unenrollDoubleCheckMobile: 'Are you sure you want to unenroll from the National Rebate below?',
        unenrollConfirmation: 'You have been unenrolled from National Account Incentives.',
        unenrollConfirmationDisclaimer: 'If you have been given a new National Agreement Code you may enroll at any time.',
        termsAndConditions: ['National Account Incentives', 'Terms & Conditions'],
        agreementDescription: {
            line1: 'Members of Pro Xtra and participating National Accounts and Affiliations may qualify for additional benefits.',
            line2: 'All forms of payment accepted at The Home Depot can be saved to your account on the',
            line3: 'Qualifying purchases can be made both online and in-store using a registered payment method',
            line4: 'Government and municipal customers who purchase from The Home Depot under the U.S. Communities (now Omnia Partners, Public Sector) Government Purchasing Alliance, or other government contracts, are ineligible to receive Pro Xtra Perks.',
        },
        name: 'Name:',
        code: 'Code:',
        enrollmentDate: 'Enrollment Date:',
        cardsAndAccountsLink: getHostURL('myaccount/payments'),
        rebate: getHostURL('c/pro_national_accounts_rebates'),
    },
    governmentBlurbs: {
        einDesc: 'As a member of Government Affiliation, you are required to enter your federally-issued Employer Identification Number (EIN).',
        einInputLabel: 'Employer Identification Number (EIN)',
        note: 'Note:',
        content: 'By clicking Enroll below you will also be unenrolled from Pro Xtra Perks, if currently enrolled.',
        warning: {
            line1: 'Government & municipal customers who purchase under this Affiliation are ineligible to receive Pro Xtra Perks:',
            line2: 'You will no longer have access to any Perks earned.',
            line3: 'You will be unenrolled from Pro Xtra Perks, if currently enrolled.',
            line4: 'If desired, please use available Perks before joining this Government Affiliation.',
            line5: 'Please select to acknowledge that you will be unenrolled from Pro Xtra Perks.',
        },
    },
};
